import { render, staticRenderFns } from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=template&id=076c1240&scoped=true&"
import script from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteIncompleteArchivesDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c1240",
  null
  
)

export default component.exports